import '../../client/index.js';
import { wrapErrorManager } from '../../utils/error-manager.js';
import { getAuthCheck } from '../auth/index.js';
import { transformSalesAgentTokenV2Response } from '../auth/transformers.js';
import { transformPosHeaderAuthRequest, transformPosSalesAgentMeResponse, transformPosSalesAgentMeRequest, transformPosSalesAgentMeQuotesResponse, transformPosSalesAgentMeQuoteResponse, transformPosSalesAgentCreateQuoteRequest, transformPosSalesAgentCreateQuoteResponse } from './transformers.js';
import { transformCrmCustomerMeOrdersV2Response, transformCrmCustomerMeOrderResponse } from '../order/transformers.js';
import defaultClient from 'axios';

const getPosSalesAgentAuthCheck = getAuthCheck.bind({});
getPosSalesAgentAuthCheck.key = 'getPosSalesAgentAuthCheck';
const getPosSalesAgentAuthRefresh = async ({ client , controller , token  } = {})=>await client.get('/V2/auth/refresh', {
        signal: controller?.signal,
        headers: {
            ...token ? {
                oauth_consumer_token: token
            } : {}
        },
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformSalesAgentTokenV2Response)
        ]
    });
getPosSalesAgentAuthRefresh.key = 'getPosSalesAgentAuthRefresh';
const postPosSalesAgentLogin = async ({ client , controller , username , password , recaptchaToken  } = {})=>{
    const params = new URLSearchParams({
        ...recaptchaToken ? {
            recaptchaToken
        } : {}
    });
    return await client.post(`V1/pos/salesagent/login${params.toString() ? `?${params.toString()}` : ''}`, {
        username,
        password
    }, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformSalesAgentTokenV2Response)
        ]
    });
};
postPosSalesAgentLogin.key = 'postPosSalesAgentLogin';
const postPosSalesAgentPasswordForgot = async ({ client , controller , recaptchaToken , recaptchaAction , email  } = {})=>{
    const params = new URLSearchParams({
        ...recaptchaToken ? {
            recaptcha_token: recaptchaToken
        } : {},
        ...recaptchaAction ? {
            recaptcha_action: recaptchaAction
        } : {}
    });
    return await client.post(`V1/pos/salesagent/password/forgot${params.toString() ? `?` + params.toString() : ''}`, {
        email
    }, {
        signal: controller?.signal
    });
};
postPosSalesAgentPasswordForgot.key = 'postPosSalesAgentPasswordForgot';
const postPosSalesAgentPasswordReset = async ({ client , controller , resetToken , salesAgentId , newPassword  } = {})=>client.post(`V1/pos/salesagent/password/reset`, {
        resetToken,
        salesAgentId,
        newPassword
    }, {
        signal: controller?.signal
    });
postPosSalesAgentPasswordReset.key = 'postPosSalesAgentPasswordReset';
const getPosSalesAgentMe = async ({ client , controller  } = {})=>client.get(`V1/pos/salesagent/me`, {
        signal: controller?.signal,
        transformRequest: [
            transformPosHeaderAuthRequest,
            ...(client || defaultClient).defaults.transformRequest
        ],
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformPosSalesAgentMeResponse)
        ]
    });
getPosSalesAgentMe.key = 'getPosSalesAgentMe';
const patchSalesAgentMePassword = async ({ client , controller , currentPassword , newPassword  })=>{
    await client.patch(`V1/pos/salesagent/me/password`, {
        currentPassword,
        newPassword
    }, {
        signal: controller?.signal,
        transformRequest: [
            transformPosHeaderAuthRequest,
            ...(client || defaultClient).defaults.transformRequest
        ]
    });
};
patchSalesAgentMePassword.key = 'patchSalesAgentMePassword';
const patchSalesAgentMe = async ({ client , controller , firstname , lastname , email , communications , companyName , description , photo , specialization , companyPhoto , streetName , city , zipcode , state , country , telephone , vatNumber  })=>{
    await client.patch(`V1/pos/salesagent/me`, {
        firstname,
        lastname,
        email,
        communications,
        companyName,
        description,
        photo,
        specialization,
        companyPhoto,
        streetName,
        city,
        zipcode,
        state,
        country,
        telephone,
        vatNumber
    }, {
        signal: controller?.signal,
        transformRequest: [
            transformPosHeaderAuthRequest,
            transformPosSalesAgentMeRequest,
            ...(client || defaultClient).defaults.transformRequest
        ],
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformPosSalesAgentMeResponse)
        ]
    });
};
patchSalesAgentMe.key = 'patchSalesAgentMe';
const getPosSalesAgentMeOrders = async ({ client , controller , offset =0 , limit =10000 , order =[]  } = {})=>await client.get(`/V1/pos/salesagent/me/orders`, {
        signal: controller?.signal,
        params: {
            filter: {
                offset,
                limit,
                order
            }
        },
        transformRequest: [
            transformPosHeaderAuthRequest,
            ...(client || defaultClient).defaults.transformRequest
        ],
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCrmCustomerMeOrdersV2Response)
        ]
    });
getPosSalesAgentMeOrders.key = 'getPosSalesAgentMeOrders';
const getPosSalesAgentMeOrder = async ({ client , controller , id  } = {})=>await client.get(`/V1/pos/salesagent/me/orders/${id}`, {
        signal: controller?.signal,
        transformRequest: [
            transformPosHeaderAuthRequest,
            ...(client || defaultClient).defaults.transformRequest
        ],
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCrmCustomerMeOrderResponse)
        ]
    });
getPosSalesAgentMeOrder.key = 'getPosSalesAgentMeOrder';
const getPosSalesAgentMeQuotes = async ({ client , controller , offset =0 , limit =10000 , order =[]  } = {})=>await client.get(`/V1/pos/salesagent/me/quotes`, {
        signal: controller?.signal,
        transformRequest: [
            transformPosHeaderAuthRequest,
            ...(client || defaultClient).defaults.transformRequest
        ],
        params: {
            filter: {
                offset,
                limit,
                order
            }
        },
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformPosSalesAgentMeQuotesResponse)
        ]
    });
getPosSalesAgentMeQuotes.key = 'getPosSalesAgentMeQuotes';
const getPosSalesAgentMeQuote = async ({ client , controller , id  } = {})=>await client.get(`/V1/pos/salesagent/me/quotes/${id}`, {
        signal: controller?.signal,
        transformRequest: [
            transformPosHeaderAuthRequest,
            ...(client || defaultClient).defaults.transformRequest
        ],
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformPosSalesAgentMeQuoteResponse)
        ]
    });
getPosSalesAgentMeQuote.key = 'getPosSalesAgentMeQuote';
const getPosSalesAgentMeClients = async ({ client , controller , offset =0 , limit =10000 , order =[]  } = {})=>await client.get(`/V1/pos/salesagent/me/clients`, {
        signal: controller?.signal,
        transformRequest: [
            transformPosHeaderAuthRequest,
            ...(client || defaultClient).defaults.transformRequest
        ],
        params: {
            filter: {
                offset,
                limit,
                order
            }
        }
    });
getPosSalesAgentMeClients.key = 'getPosSalesAgentMeClients';
const postPosSalesAgentMeCreateQuote = async ({ client , controller , name , customerId , quoteDescription , quoteAdditionalDescription  } = {})=>{
    return await client.post(`/V1/pos/salesagent/me/quote/request`, {
        name,
        customerId,
        quoteDescription,
        quoteAdditionalDescription
    }, {
        signal: controller?.signal,
        transformRequest: [
            transformPosHeaderAuthRequest,
            transformPosSalesAgentCreateQuoteRequest,
            ...(client || defaultClient).defaults.transformRequest
        ],
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformPosSalesAgentCreateQuoteResponse)
        ]
    });
};
postPosSalesAgentMeCreateQuote.key = 'postPosSalesAgentMeCreateQuote';

export { getPosSalesAgentAuthCheck, getPosSalesAgentAuthRefresh, getPosSalesAgentMe, getPosSalesAgentMeClients, getPosSalesAgentMeOrder, getPosSalesAgentMeOrders, getPosSalesAgentMeQuote, getPosSalesAgentMeQuotes, patchSalesAgentMe, patchSalesAgentMePassword, postPosSalesAgentLogin, postPosSalesAgentMeCreateQuote, postPosSalesAgentPasswordForgot, postPosSalesAgentPasswordReset };
